import { render } from "./EditUserCapability.vue?vue&type=template&id=1c6f66b1"
import script from "./EditUserCapability.vue?vue&type=script&lang=js"
export * from "./EditUserCapability.vue?vue&type=script&lang=js"
script.render = render

export default script